import './index.css'

import {Component} from 'react'

import TodoItem from '../TodoItem'

const initialTodosList = [
  {
    id: 1,
    title: 'Book the ticket for today evening',
  },
  {
    id: 2,
    title: 'Rent the movie for tomorrow movie night',
  },
  {
    id: 3,
    title: 'Confirm the slot for the yoga session tomorrow morning',
  },
  {
    id: 4,
    title: 'Drop the parcel at Bloomingdale',
  },
  {
    id: 5,
    title: 'Order fruits on Big Basket',
  },
  {
    id: 6,
    title: 'Fix the production issue',
  },
  {
    id: 7,
    title: 'Confirm my slot for Saturday Night',
  },
  {
    id: 8,
    title: 'Get essentials for Sunday car wash',
  },
]

// Write your code here

class SimpleTodos extends Component {
  state = {
    todoListItems: initialTodosList,
  }

  onDelete = deleteId =>
    this.setState(preveState => {
      const {todoListItems} = this.state
      const filteredTodoItems = todoListItems.filter(
        eachItem => eachItem.id !== deleteId,
      )
      return {
        todoListItems: filteredTodoItems,
      }
    })

  render() {
    const {todoListItems} = this.state
    return (
      <div className="bg-container">
        <div className="card-container">
          <h1 className="todo-card-heading">Simple Todos</h1>
          <ul className="todo-item-container">
            {todoListItems.map(eachItem => (
              <TodoItem
                key={eachItem.id}
                item={eachItem}
                onDelete={this.onDelete}
              />
            ))}
          </ul>
        </div>
      </div>
    )
  }
}

export default SimpleTodos
